import { render, staticRenderFns } from "./CoownerForm.vue?vue&type=template&id=5f02b975&scoped=true&"
import script from "./CoownerForm.vue?vue&type=script&lang=js&"
export * from "./CoownerForm.vue?vue&type=script&lang=js&"
import style0 from "./CoownerForm.vue?vue&type=style&index=0&id=5f02b975&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f02b975",
  null
  
)

export default component.exports